import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function TableActionButtons({ buttons }) {
  if (!buttons?.length) return;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
      }}
    >
      {buttons?.map(i => (
        <BtnLayout {...i} key={i.label} />
      ))}
    </Box>
  );
}

const BtnLayout = ({ label, Icon, onClick, color, variant = 'contained' }) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      size="small"
      color={color}
      startIcon={<Icon style={{ margin: '0 -.5rem 0 .5rem' }} />}
    >
      {label}
    </Button>
  );
};
